<template>
  <div>
    <v-chip v-for="(tag, i) in _tags" :key="i" x-small pill color="primary" class="mr-1">
      {{ capitalizeFirstLetter(tag) }}
    </v-chip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'TagsRow',
  props: {
    tags: { type: Array, default: () => [] },
  },
  computed: {
    _tags() {
      return this.tags.map((tag) => tag.tag.tag)
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
  },
}
</script>

<style lang="less" scoped></style>
